import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';

function Industries() {
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchIndustries();
  }, []);

  const fetchIndustries = async () => {
    try {
      const response = await fetch(`${baseURL}/industries.php`);
      if (response.ok) {
        const data = await response.json();
        setIndustries(data);
      } else {
        throw new Error('Failed to fetch industries data');
      }
    } catch (err) {
      setError('Error loading industries. Please try again later.');
      console.error('Error fetching industries:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-2">Loading industries...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">{error}</Alert>
        <div className="text-center">
          <Button onClick={fetchIndustries} variant="primary">
            Try Again
          </Button>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row className="mb-5">
        <Col>
          <h1 className="text-center royal-blue-text emerald-green-border mb-4">Industries We Serve</h1>
          <p className="lead text-center">
            We provide specialized laboratory solutions tailored to the unique needs of various industries 
            across East Africa and beyond.
          </p>
        </Col>
      </Row>

      <Row>
        {industries.length > 0 ? (
          industries.map((industry) => (
            <Col lg={4} md={6} className="mb-4" key={industry.id}>
              <Card className="service-card h-100 text-center">
                <Card.Body className="p-4">
                  <div className="royal-blue-text mb-3">
                    <i className={`${industry.icon} fa-3x`}></i>
                  </div>
                  <Card.Title className="royal-blue-text h5">{industry.name}</Card.Title>
                  <Card.Text>{industry.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          // Fallback industries if database is empty
          [
            {
              id: 1,
              name: "Research & Education",
              description: "Supporting universities, research institutions, and educational laboratories with advanced analytical equipment and training.",
              icon: "fas fa-flask"
            },
            {
              id: 2,
              name: "Pharmaceuticals & Biotechnology",
              description: "Providing precision instruments for drug development, quality control, and biotech research.",
              icon: "fas fa-pills"
            },
            {
              id: 3,
              name: "Food & Beverage Testing",
              description: "Ensuring food safety and quality with reliable testing equipment and analytical solutions.",
              icon: "fas fa-utensils"
            },
            {
              id: 4,
              name: "Environmental & Water Analysis",
              description: "Monitoring and analyzing environmental samples and water quality with accurate testing systems.",
              icon: "fas fa-tint"
            },
            {
              id: 5,
              name: "Petrochemical & Industrial Laboratories",
              description: "Supporting industrial quality control and research with robust analytical instruments.",
              icon: "fas fa-industry"
            },
            {
              id: 6,
              name: "Veterinary Laboratories",
              description: "Equipping veterinary labs with reliable diagnostic and analytical equipment.",
              icon: "fas fa-clinic-medical"
            }
          ].map((industry) => (
            <Col lg={4} md={6} className="mb-4" key={industry.id}>
              <Card className="service-card h-100 text-center">
                <Card.Body className="p-4">
                  <div className="royal-blue-text mb-3">
                    <i className={`${industry.icon} fa-3x`}></i>
                  </div>
                  <Card.Title className="royal-blue-text h5">{industry.name}</Card.Title>
                  <Card.Text>{industry.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))
        )}
      </Row>

      {/* Regional Coverage */}
      <Row className="mt-5">
        <Col>
          <Card className="bg-primary text-white">
            <Card.Body className="p-5 text-center">
              <h3 className="mb-3">Our Regional Coverage</h3>
              <p className="lead mb-4">
                Serving clients across Kenya, Uganda, Tanzania, Rwanda, Ethiopia, Somalia, Somaliland, and beyond.
              </p>
              <p className="mb-0">
                Our strong regional presence, skilled technical team, and reliable supply network ensure 
                timely delivery, professional support, and long-term partnerships built on quality and trust.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Industries;